module.exports = __webpack_public_path__ + "img/ac.76b56748.png";